module.exports = __webpack_public_path__ + "static/media/gainChevrron.3a7d3c44.svg";